import { Bell, MailWarning, SlidersHorizontal } from 'lucide-react';
import type { router as AppRouter } from '../../router';
import { registerCommands, type Command } from '../../shell/command-registry';

/**
 * S8's palette entries, registered from this module rather than by editing
 * `shell-commands.ts` — 06-qol §1's registration pattern.
 *
 * The inbox and the settings screen carry no `permission`: everybody has
 * notifications, and the routes behind them are `@Authenticated` rather than
 * permission-checked for exactly that reason. The delivery log names
 * `admin_config`, so nobody sees a destination they would be refused at.
 */
export function registerNotificationCommands(router: typeof AppRouter): () => void {
  const commands: Command[] = [
    {
      id: 'notifications.inbox',
      label: 'Notifications',
      section: 'navigate',
      context: 'Screen · NOTIF-01',
      icon: Bell,
      keywords: ['inbox', 'alerts', 'unread', 'bell', 'messages'],
      run: () => void router.navigate({ to: '/notifications' }),
    },
    {
      id: 'notifications.preferences',
      label: 'Notification settings',
      section: 'navigate',
      context: 'Screen · NOTIF-02',
      icon: SlidersHorizontal,
      keywords: ['preferences', 'email', 'digest', 'mute', 'channels', 'subscribe'],
      run: () => void router.navigate({ to: '/notifications/preferences' }),
    },
    {
      id: 'admin.emailDelivery',
      label: 'Email delivery',
      section: 'navigate',
      context: 'Screen · S8',
      permission: 'admin_config',
      icon: MailWarning,
      keywords: ['email', 'smtp', 'failed', 'bounced', 'delivery', 'outbox', 'sent'],
      run: () => void router.navigate({ to: '/admin/email' }),
    },
  ];

  return registerCommands(commands);
}
